export default __webpack_public_path__ + "static/media/feliphe-schiarolli-oeHaXN3WiLk-unsplash-1.e9e0dbd8.jpg";